"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normaliseAccountCode = void 0;
/**
 * Account codes (e.g. `DO2037`, `YVS123`) are case-sensitive keys throughout
 * Firestore — account, booking, job and image documents are all queried with
 * case-sensitive equality on the code, so a lower-case code silently fails to
 * match its own records.
 *
 * Always normalise operator-entered or externally-sourced account codes with this
 * helper before writing them to, or querying with, Firestore.
 */
function normaliseAccountCode(code) {
    return code.trim().toUpperCase();
}
exports.normaliseAccountCode = normaliseAccountCode;
